<template>
  <div class="list-editor">
    <el-form ref="form" label-width="100px">
      <el-form-item label="上边距">
        <el-slider v-model="currentItem.style.margin_top" style="padding-left:10px;"></el-slider>
      </el-form-item>
      <el-form-item label="左右边距">
        <el-slider v-model="currentItem.style.padding" style="padding-left:10px;"></el-slider>
      </el-form-item>
      <!-- <el-form-item label="标题">
        <el-input v-model="currentItem.title"></el-input>
      </el-form-item> -->
      <el-form-item label="选择展映">
        <el-select v-model="currentItem.list" multiple clearable placeholder="请选择" style="width:400px">
          <el-option
            v-for="item in list"
            :key="item.id"
            :label="item.title"
            :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import request from '@/utils/request'
export default {
  name: 'discussionEditor',
  data () {
    return {
      list: []
    }
  },
  computed: {
    currentItem () {
      return this.$store.state.page.currentItem
    }
  },
  created () {
    this.getMovies()
  },
  methods: {
    getMovies () {
      request({
        url: '/movie/articles?type=discussion'
      }).then(res => {
        this.list = res.data.list
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/PageEditor/editors/discussionEditor.vue